import React from 'react'

const Title = ({ title, number }) => (
  <div className='page-title grid' data-sal='slide-down' data-sal-duration='1000' data-sal-easing='ease-out'>
    <h1>{title} {number && <sup>{number}</sup>}</h1>
  </div>
)

export default Title
